import { render } from "./StatistikaPart.vue?vue&type=template&id=cefdd8ae"
import script from "./StatistikaPart.vue?vue&type=script&lang=js"
export * from "./StatistikaPart.vue?vue&type=script&lang=js"

import "./StatistikaPart.vue?vue&type=style&index=0&id=cefdd8ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__